import styles from "./index.module.less";
import ProductCard from "../ProductCard";
import classNames from "classnames";
import { useEffect, useRef, useState } from "react";
import ArrowLeftIcon from "@/assets/imgs/arrow_left.svg?react";
import ArrowRightIcon from "@/assets/imgs/arrow_right.svg?react";

import { useNavigate } from "react-router-dom";
import SVGIcon from "@/components/SVGIcon";

import {  getProducts } from "@/constants/product";
const products = getProducts();
const swiperProducts = [...products, ...products, ...products];
const ProductList = () => {
  const [index, setIndex] = useState(0);
  // 数字员工企业版为第一个
  const [realIndex, setRealIndex] = useState(1);
  useEffect(() => {
    setRealIndex(index % products.length);
  }, [index]);
  const swiperRef = useRef<any>(null);
  useEffect(() => {
    swiperRef.current = new window.Swiper(".productSwiper", {
      loop: true,
      slidesPerView: "auto",
      //   loopedSlides: 7,
      initialSlide: 0,
      centeredSlides: true,
      slideToClickedSlide: true,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
      },
      on: {
        slideChangeTransitionStart: (swiper: any) => {
          setIndex(swiper.realIndex);
        },
      },
    });
  }, []);
  const handleNext = () => {
    swiperRef.current.slideNext();
  };
  const handlePrev = () => {
    swiperRef.current.slidePrev();
  };
  const navigate = useNavigate();
  return (
    <div className={styles.productList}>
      <div className="swiper productSwiper">
        <div className="swiper-wrapper">
          {swiperProducts.map((product, i) => (
            <div
              key={i}
              className={classNames(styles.productCard, "swiper-slide")}
              onClick={() => {
                navigate(`/${product.value}`);
                // window.location.href = `/${product.value}`;
              }}
            >
              <ProductCard
                {...product}
                isActive={product.value === swiperProducts[index].value}
              />
            </div>
          ))}
        </div>
      </div>
      <div className={styles.pagination}>
        <div className={styles.prevBtn} onClick={handlePrev}>
          <SVGIcon icon={<ArrowLeftIcon />} />
        </div>
        <div className={styles.nextBtn} onClick={handleNext}>
          <SVGIcon icon={<ArrowRightIcon />} />
        </div>
      </div>
    </div>
  );
};
export default ProductList;
